// Connect visitor-session change notifications.
//
// Most Connect sign-in paths end in a full navigation (the header modal and the
// emailed magic link both land on a fresh page), so the server-rendered chrome
// comes back with the right state. The in-page flows — the Home Value AVM
// registration gate, the pre-approval form — establish the session with a
// fetch and never reload, which left the header still showing "Sign in" until
// the visitor hard-refreshed.
//
// Anything that establishes (or ends) a session without navigating announces it
// here; anything that renders session-dependent UI listens and re-probes
// /account/session for itself.
export const CONNECT_SESSION_EVENT = "connect:session-changed";

export function announceSessionChange(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(CONNECT_SESSION_EVENT, { detail }));
  } catch (_e) {
    /* CustomEvent unsupported — non-fatal, the next page load fixes the UI */
  }
}
